import { render } from "./FraudRisk.vue?vue&type=template&id=c6186498"
import script from "./FraudRisk.vue?vue&type=script&lang=js"
export * from "./FraudRisk.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__